import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ApplicationFormFields from './ApplicationFormFields';

const ApplicationForm = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    specialization: '',
    employment_status: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send the data to your backend
    alert('Application submitted successfully!');
    onHide();
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      course: '',
      specialization: '',
      employment_status: ''
    });
  };

  return (
    <>
      {/* Main Application Modal */}
      <Modal show={show} onHide={onHide} size="md" centered className="application-modal">
        <Modal.Header closeButton className="border-0 pb-0">
          <div className="text-center w-100">
            <img className="img-fluid mb-3" src="/assets/img/mewar-logo.png" alt="Mewar University" style={{ maxHeight: '80px' }} />
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="text-center mb-4">
            <h4 className="fw-bold text-dark mb-0">B.Tech Lateral Entry Program</h4>
          </div>
          
          <ApplicationFormFields 
            formData={formData}
            onInputChange={handleInputChange}
            onSubmit={handleSubmit}
            submitButtonText="Apply Now"
            showPrivacyNote={true}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ApplicationForm;
